import React from "react";
import GenericDrawer from "./GenericDrawer.js";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors/index.js";
import { DrawerType, VerticalTransition } from "../../constants/index.js";
import QuickLinksMenu from "../MenuV2/QuickLinksMenu.js";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader.js";
import { useNoScroll } from "../../hooks/index.js";

const QuickLinksInnerDrawer = function () {
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );

  useNoScroll("quickLinksInnerDrawer", quickLinksInnerMenuVisible);

  return (
    <GenericDrawer
      isVisible={quickLinksInnerMenuVisible}
      menu={DrawerType.QuickLinksInnerMenu}
      header={<MobileDrawerHeader menu={DrawerType.QuickLinksInnerMenu} />}
      verticalTransition={VerticalTransition.Left}
    >
      <QuickLinksMenu />
    </GenericDrawer>
  );
};

export default React.memo(QuickLinksInnerDrawer);
